import { Routes, Route, Outlet } from "react-router-dom";
import { registerValidateFormats, registerValidateLocale } from "@formily/core";
import AuthProvider from "@/components/auth/AuthProvider";
import AuthLayout from "@/components/auth/Layout";
import Login from "@/components/auth/Login";
import ResetPassword from "@/components/auth/ResetPassword";
import Profile from "@/components/auth/Profile";
import RequireAuth from "@/components/auth/RequireAuth";
import WelcomeLayout from "@/components/welcome/Layout";
import WorkshopLayout from "@/components/workshop/Layout";
import WorkshopIndex from "@/components/workshop/Index";
import ProcessMessage from "@/components/workshop/message/ProcessMessage";
import BacklogMessage from "@/components/workshop/message/BacklogMessage";
import ReceiveMessage from "@/components/workshop/message/ReceiveMessage";
import DraftMessage from "@/components/workshop/message/DraftMessage";
import SubmitMessage from "@/components/workshop/message/SubmitMessage";
import MessageForm from "@/components/workshop/message/MessageForm";
import MessageDetail from "@/components/workshop/message/MessageDetail";
import DraftAnnouncement from "@/components/workshop/announcement/DraftAnnouncement";
import ReceiveAnnouncement from "@/components/workshop/announcement/ReceiveAnnouncement";
import AnnouncementForm from "@/components/workshop/announcement/AnnouncementForm";
import AnnouncementDetail from "@/components/workshop/announcement/AnnouncementDetail";
import DepartmentLayout from "@/components/workshop/department/Layout";
import DepartmentIndex from "@/components/workshop/department/Index";
import DepartmentDetail from "@/components/workshop/department/Detail";
import AddressBookLayout from "@/components/workshop/addressbook/Layout";
import AddressBookIndex from "@/components/workshop/addressbook/Index";
import AddressBookPrintLayout from "@/components/workshop/addressbook/Print";
import WordStock from "@/components/workshop/setting/WordStock";
import MessageType from "@/components/workshop/setting/MessageType";
import ReportType from "@/components/workshop/setting/ReportType";
import Publication from "@/components/workshop/setting/Publication";
import AdditionalPoint from "@/components/workshop/setting/AdditionalPoint";
import DeductPoint from "@/components/workshop/setting/DeductPoint";
import AnnouncementStatistic from "@/components/workshop/statistic/AnnouncementStatistic";
import MessageStatistic from "@/components/workshop/statistic/MessageStatistic";
import TotalStatistic from "@/components/workshop/statistic/TotalStatistic";
import "./App.less";

registerValidateFormats({
  password:
    /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{12,}$/,
});

registerValidateLocale({
  zh: {
    password: "密码必须不少于12位，且有大写字母、小写字母、数字、符号",
  },
  en: {
    password: "密码必须不少于12位，且有大写字母、小写字母、数字、符号",
  },
  "en-US": {
    password: "密码必须不少于12位，且有大写字母、小写字母、数字、符号",
  },
  "zh-CN": {
    password: "密码必须不少于12位，且有大写字母、小写字母、数字、符号",
  },
});

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<AuthLayout />}>
          <Route index element={<Login />} />
          <Route path="/reset" element={<ResetPassword />} />
        </Route>
        <Route
          path="/addressbook"
          element={
            <RequireAuth>
              <AddressBookPrintLayout />
            </RequireAuth>
          }
        />
        <Route path="/profile" element={<Profile />} />
        <Route
          path="/index"
          element={
            <RequireAuth>
              <WelcomeLayout />
            </RequireAuth>
          }
        />
        <Route
          path="/workshop"
          element={
            <RequireAuth>
              <WorkshopLayout />
            </RequireAuth>
          }
        >
          <Route index element={<WorkshopIndex />} />
          <Route path="mproc" element={<Outlet />}>
            <Route path=":statusType" element={<ProcessMessage />} />
            <Route path="backlog" element={<BacklogMessage />} />
          </Route>
          <Route path="mrece" element={<Outlet />}>
            <Route index element={<ReceiveMessage />} />
            <Route path=":departmentType" element={<ReceiveMessage />} />
            <Route path="detail/:messageId" element={<MessageDetail />} />
          </Route>
          <Route path="announce" element={<Outlet />}>
            <Route path="form/new" element={<AnnouncementForm />} />
            <Route path="form/:announcementId" element={<AnnouncementForm />} />
            <Route path="draft" element={<DraftAnnouncement />} />
            <Route path=":column" element={<ReceiveAnnouncement />} />
            <Route
              path="detail/:announcementId"
              element={<AnnouncementDetail />}
            />
          </Route>
          <Route path="msubm" element={<Outlet />}>
            <Route path="form/new" element={<MessageForm />} />
            <Route path="form/:messageId" element={<MessageForm />} />
            <Route path="draft" element={<DraftMessage />} />
            <Route path="draft/finished" element={<SubmitMessage />} />
            <Route path="detail/:messageId" element={<MessageDetail />} />
          </Route>
          <Route path="addressbook" element={<AddressBookLayout />}>
            <Route index element={<AddressBookIndex />} />
          </Route>
          <Route path="department" element={<DepartmentLayout />}>
            <Route index element={<DepartmentIndex />} />
            <Route path=":departmentId" element={<DepartmentDetail />} />
          </Route>
          <Route path="setting" element={<Outlet />}>
            <Route path="word" element={<WordStock />} />
            <Route path="mtype" element={<MessageType />} />
            <Route path="rtype" element={<ReportType />} />
            <Route path="pub" element={<Publication />} />
            <Route path="apoint" element={<AdditionalPoint />} />
            <Route path="dpoint" element={<DeductPoint />} />
          </Route>
          <Route path="statistic" element={<Outlet />}>
            <Route path="anno" element={<AnnouncementStatistic />} />
            <Route path="mess" element={<MessageStatistic />} />
            <Route path="total" element={<TotalStatistic />} />
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
